import React from "react"
import autobind from "class-autobind"
import { IWorkflow } from "../../models"

interface IProps {
    workflow: IWorkflow
    style?: object
    showTitles?: boolean
}

interface IState {
}

export default class WorkflowDescription extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    render() {
        let accentColor = "#02bcf5"

        return (
            <div style={this.props.style}>
                {this.props.workflow.ImageUrl &&
                    <div style={{ display: "flex", maxWidth: 1200 }}>
                        <div style={{ flexBasis: "66.66%", paddingRight: 10 }}>
                            {this.props.showTitles &&
                                <div>
                                    <h1 style={{ margin: 0 }}>{this.props.workflow.Name}</h1>
                                    <h4 style={{ marginTop: 0, color: accentColor }}>{this.props.workflow.SubTitle}</h4>
                                </div>
                            }
                            <div dangerouslySetInnerHTML={{ __html: this.props.workflow.DescriptionHTML }} />
                        </div>
                        <div style={{ flexBasis: "33.33%", paddingLeft: 10 }}>
                            <img src={this.props.workflow.ImageUrl} />
                        </div>
                    </div>
                }
                {!this.props.workflow.ImageUrl &&
                    <div dangerouslySetInnerHTML={{ __html: this.props.workflow.DescriptionHTML }} />
                }
            </div>
        )
    }
}